
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-x-request-demo-basic","docs-x-sdk-x-request-demo-custom-params","docs-x-sdk-x-request-demo-custom-transformer","docs-x-sdk-x-request-demo-model","docs-x-sdk-x-request-demo-timeout"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.zh-CN.md?type=demo')
};